import { Link } from "@tanstack/react-router";
import { Avatar, Button, Card } from "@/components/ui";
import type { Creator, CreatorSummary } from "@/api/types";
import { formatCompact } from "@/lib/format";
import { useFollowCreator } from "@/api/queries/creators";

export type CreatorCardCreator = Creator | (CreatorSummary & { followers?: number; isFollowing: boolean });

export function CreatorCard({ creator }: { creator: CreatorCardCreator }) {
  const follow = useFollowCreator();
  return (
    <Card className="flex flex-col items-center text-center">
      <Avatar size="xl" alt={creator.displayName} verified={creator.verified} />
      <Link
        to="/@{$username}"
        params={{ username: creator.username }}
        className="mt-3 focus-visible:outline-2 focus-visible:outline-primary"
      >
        <h3 className="text-h5 text-text-primary">{creator.displayName}</h3>
        <p className="font-mono text-mono text-text-muted">@{creator.username}</p>
        <p className="mt-1 text-caption text-text-secondary">{creator.role}</p>
        {creator.followers !== undefined && (
          <p className="mt-1 text-caption text-text-secondary tnum">
            {formatCompact(creator.followers)} followers
          </p>
        )}
      </Link>
      <Button
        className="mt-3 w-full"
        size="sm"
        variant={creator.isFollowing ? "secondary" : "primary"}
        onClick={(event) => {
          event.preventDefault();
          follow.mutate({ username: creator.username, following: !creator.isFollowing });
        }}
        disabled={follow.isPending}
      >
        {creator.isFollowing ? "Following" : "Follow"}
      </Button>
    </Card>
  );
}
